import { useCallback, useRef } from 'react';
import { graphql } from '../graphql';
import { v4 } from 'uuid';
import { encode } from 'base64-arraybuffer';
import { useMutation } from '@apollo/client';
import { imageSize } from '../lib/metrics';
import { log } from '../lib/logger';
import { i18n } from '../i18n';
import { useLineOfBusiness } from './useLineOfBusiness';
export const UPLOAD_FILE = graphql(`
  mutation UploadFile(
    $id: String!
    $fileName: String!
    $fileContent: String!
    $timestamp: String!
    $caption: String
  ) {
    uploadFile(
      input: {
        id: $id
        fileName: $fileName
        fileContent: $fileContent
        timestamp: $timestamp
        caption: $caption
      }
    )
  }
`);
const getBase64 = (file) => file.arrayBuffer().then(content => encode(content));
export const getHandleFileUpload = (uploadFile) => (file, caption) => {
    const id = v4();
    getBase64(file).then(content => {
        return uploadFile({
            variables: {
                id,
                fileName: file.name,
                fileContent: content,
                timestamp: Date.now().toString(),
                caption: caption,
            },
        });
    });
    return {
        id,
        attachmentLink: URL.createObjectURL(file),
        caption: caption,
    };
};
export const getHandleFileChange = (lineOfBusiness, onError) => (e) => {
    var _a, _b, _c;
    if (((_a = e.target.files) === null || _a === void 0 ? void 0 : _a.length) !== 1) {
        onError(i18n.t('FILE_NOT_SELECTED_TEXT'));
        return;
    }
    const file = (_b = e.target.files) === null || _b === void 0 ? void 0 : _b[0];
    imageSize(lineOfBusiness, file.size).catch(log.error);
    if (file.size > 2000000) {
        onError(i18n.t('FILE_TOO_BIG_TEXT'));
        return;
    }
    const extension = (_c = file.name.split('.').pop()) === null || _c === void 0 ? void 0 : _c.toLowerCase();
    const allowedExtensions = ['jpg', 'jpeg', 'png'];
    if (!allowedExtensions.includes(extension !== null && extension !== void 0 ? extension : '')) {
        onError(`Sorry, but the file type .${extension} is not allowed.`);
        return;
    }
    return URL.createObjectURL(file);
};
export const useUploadFile = ({ onError, }) => {
    const [uploadFile] = useMutation(UPLOAD_FILE);
    const inputRef = useRef(null);
    const handleUploadFile = getHandleFileUpload(uploadFile);
    const { lineOfBusiness } = useLineOfBusiness();
    const handleFileChange = getHandleFileChange(lineOfBusiness, onError);
    const handleAttachmentClick = useCallback(() => {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    return {
        inputRef,
        handleFileChange,
        handleAttachmentClick,
        handleUploadFile,
    };
};
//# sourceMappingURL=useUploadFile.js.map